import React, { useState, useEffect, useRef } from "react";
import "./Content.css";
import api from "../../services/baseUrl";
import { CircularProgress, Divider } from "@mui/material";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Search from "../../components/Search";
import { useLibrary } from "../../context/LibraryContext";
import PrintHtml from "../../components/PrintHtml";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HtmlWithPdfLinks from "../../components/HtmlWithPdfLinks";
import download from "downloadjs";
export default function LawLibraryContent() {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const subdocumentId = queryParams.get("subdocumentId");
  const [subDocumentList, setsubDocumentList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { libraryId, setLibraryId } = useLibrary();
  const contentRef = useRef();
  const [isBookmarked, setIsBookmarked] = useState(false);
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const user = JSON.parse(cookie).user;
  const [documentId, setDocumentId] = useState("");

  let prevPart = null;
  let prevChapter = null;

  const fetchSubdocumentList = async (documentID) => {
    try {
      const response = await api.get(`api/lawlibrary-documents/${documentID}`);
      setsubDocumentList(
        response.data.subdocuments.filter(
          (subdocument) => subdocument.typeId !== 1
        )
      );
    } catch (err) {
      setError(err.message || "Error fetching data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (searchQuery) => {
    const globalPayload = {
      query: searchQuery.searchQuery,
      type: "content",
      modules: "lawlibrary",
      search: searchQuery.keyword,
      library: libraryId,
      limit: searchQuery.limit,
      offset: searchQuery.offset,
      documentID: data.documentID,
      documentName: data.title,
    };

    const queryString = new URLSearchParams(globalPayload).toString();
    console.log(queryString);

    // Navigate with query params
    navigate(`/law-library/search?${queryString}`);
  };

  // This useEffect triggers fetchData when subdocumentId changes
  useEffect(() => {
    const fetchData = async (subDocumentID) => {
      setIsLoading(true);
      try {
        const response = await api.get(
          `api/lawlibrary-documents/subdocument/${subDocumentID}`
        );
        setData(response.data); // This triggers the state update

        if (libraryId === null) {
          setLibraryId(response.data.library.libraryId);
        }
      } catch (err) {
        setError(err.message || "Error fetching data");
        console.error(error);
      }
    };

    if (subdocumentId) {
      fetchData(subdocumentId);
    }
  }, [subdocumentId, error, libraryId, setLibraryId]);

  // This useEffect triggers fetchSubdocumentList when data.documentID changes
  useEffect(() => {
    if (data && data.documentID) {
      setDocumentId(data.documentID);
      fetchSubdocumentList(data.documentID);
    }
  }, [data]);

  useEffect(() => {
    const checkBookmark = async () => {
      const response = await api.get("/bookmark/check", {
        params: {
          username: user.userName,
          subDocumentId: subdocumentId,
          documentType: "LawLibrary",
        },
      });
      setIsBookmarked(response.data.bookmarked);
    };
    if (subdocumentId) {
      checkBookmark();
    }
  }, [subdocumentId, user.userName]);

  const isNewPart = (part) => {
    if (part !== "" && part !== prevPart) {
      prevPart = part;
      return part;
    } else {
      return null;
    }
  };

  const isNewChapter = (chapter) => {
    if (chapter !== "" && chapter !== prevChapter) {
      prevChapter = chapter;
      return chapter;
    } else {
      return null;
    }
  };

  const handleNavigation = (subDocumentId) => {
    navigate(`/law-library/document?subdocumentId=${subDocumentId}`);
  };

  const handleIndexNavigation = (documentId) => {
    navigate(`/law-library/document?documentID=${documentId}`);
  };

  const openOtherVersion = async (subDocumentId, orderId) => {
    try {
      const response = await api.post(
        "api/lawlibrary-documents/subdocument/getOtherVersion",
        {
          subDocumentId,
          orderId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data !== undefined) {
        window.open(
          `/law-library/document?subdocumentId=${response.data}`,
          "_blank"
        );
      } else {
        window.alert("Sorry, there is no other version of this document.");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const versioningLibrary = {
    2: "Original",
    12: "Original",
    1: "Updated",
    11: "Updated",
    8: "Asal",
    14: "Asal",
    9: "Terbaru",
    13: "Terbaru",
  };

  const label = versioningLibrary[libraryId];

  const handleBookmarkClick = async () => {
    if (isBookmarked) {
      const response = await api.delete("/bookmark/remove", {
        data: {
          username: user.userName,
          subDocumentId: subdocumentId,
          documentType: "LawLibrary",
        },
      });
      if (response.status === 200) {
        toast.success("Bookmark is removed.");
      }
    } else {
      const response = await api.post("/bookmark/add", {
        username: user.userName,
        documentId: documentId,
        subDocumentId: subdocumentId,
        documentType: "LawLibrary",
      });
      if (response.status === 200) {
        toast.success("Bookmark is added.");
      }
    }

    checkBookmark();
  };

  const checkBookmark = async () => {
    const response = await api.get("/bookmark/check", {
      params: {
        username: user.userName,
        subDocumentId: subdocumentId,
        documentType: "LawLibrary",
      },
    });
    setIsBookmarked(response.data.bookmarked);
  };

  const fetchPdf = async (documentID) => {
    try {
      const response = await api.post(
        "/document/pdf/download/documentID",
        { documentID },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );

      const fileNameResponse = await api.post(
        "/document/pdf/getFileName/documentID",
        { documentID },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const fileName = fileNameResponse.data;

      const contentType = response.headers["content-type"];
      download(response.data, fileName.split("/").pop(), contentType);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };
  return (
    <>
      {!isLoading ? (
        <div className="ll-content-container">
          <div className="ll-section-list">
            <h3>List of Provisions</h3>
            <p>{data?.title}</p>
            <ul className="ll-section-ul">
              {subDocumentList.map((subDocument, index) => {
                return (
                  <li key={index}>
                    {/* Display part if it changes */}

                    {<p>{isNewPart(subDocument.part)}</p>}

                    {/* Display chapter if it changes */}
                    {<p>{isNewChapter(subDocument.chapter)}</p>}

                    {/* Display subtitle */}
                    <p
                      className="section"
                      onClick={() => {
                        handleNavigation(subDocument?.subdocumentID);
                      }}
                    >
                      {subDocument.subTitle}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="ll-content">
            <div className="law-library-content-search-and-print">
              <Search
                onSearch={handleSearch}
                placeholder={"Enter keyword to search"}
              />
              <button
                className="print-law-library-btn"
                onClick={handleBookmarkClick}
                style={{ marginTop: "20px", padding: "5px" }}
              >
                {isBookmarked ? "Remove Bookmark" : "Add to Bookmark"}
              </button>
              <PrintHtml contentRef={contentRef} />
            </div>
            <div className="ll-content-navigation-buttons">
              {data?.previousSubDocumentId && (
                <span
                  className="nav-button previous"
                  onClick={() => {
                    handleNavigation(data?.previousSubDocumentId);
                  }}
                >
                  <FaArrowAltCircleLeft /> Previous
                </span>
              )}
              <span
                className="nav-button center"
                onClick={() => {
                  handleIndexNavigation(data?.documentID);
                }}
              >
                Table of Contents
              </span>
              {data?.nextSubDocumentId && (
                <span
                  className="nav-button next"
                  onClick={() => {
                    handleNavigation(data?.nextSubDocumentId);
                  }}
                >
                  Next <FaArrowAltCircleRight />
                </span>
              )}
            </div>
            <div ref={contentRef}>
              <div className="ll-content-title">
                <p>{data?.no}</p>
                <p>{data?.title}</p>
              </div>
              <Divider />
              {data && (
                <div className="ll-content-list">
                  {data.currentSubdocument && (
                    <>
                      <div className="subDocument-subTitle">
                        <p style={{ fontWeight: "bold", fontSize: "20px" }}>
                          {data.currentSubdocument.subTitle}
                        </p>
                        {label &&
                          data.currentSubdocument.otherVersionId !== null && (
                            <span
                              onClick={() => {
                                openOtherVersion(
                                  data.currentSubdocument.subdocumentID,
                                  data.currentSubdocument.orderId
                                );
                              }}
                              style={{
                                cursor: "pointer",
                                color: "blue",
                                textDecoration: "underline",
                              }}
                            >
                              ({label})
                            </span>
                          )}
                      </div>
                      <div className="subDocument-content">
                        <HtmlWithPdfLinks
                          bodyHtml={data.currentSubdocument.bodyHtml}
                          fetchPdf={fetchPdf}
                        />
                      </div>
                    </>
                  )}
                  {!data.currentSubdocument && (
                    <p>Subdocument content is not available.</p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="loading-container">
          <CircularProgress />
        </div>
      )}
      <ToastContainer />
    </>
  );
}
